/**
 * Task list configuration for a record's Tasks tab.
 *
 * The twin of `noteListConfig`, exactly as the slideout's Tasks section is the
 * twin of its Notes section. Tasks are created through the shared
 * composer (a staged composition) rather than the generic create form, so there
 * are no create properties here.
 *
 * Columns: Task (object_name preview) · Status (pipeline stage) · Due ·
 * Owner · Updated At. An association column takes its header from that
 * association's own schema label, so `ahoy_task_to_owner` renders as "Owner".
 */

import type { ListPageConfig } from '../../core/types';

export const taskListConfig: ListPageConfig = {
  entityType: 'ahoy_task',
  title: 'Task',
  pluralTitle: 'Tasks',

  columns: [
    { kind: 'object_name', sortable: true, width: 360 },
    { kind: 'association', name: 'ahoy_task_to_task_pipeline_stage' },
    { kind: 'property', name: 'ahoy_date' },
    { kind: 'association', name: 'ahoy_task_to_owner' },
    { kind: 'property', name: 'ahoy_updated_at' },
  ],

  createProperties: [],
  createAssociations: [],
  metrics: [],

  // Most-recently-updated tasks first, matching the notes tab.
  defaultFilters: {
    page: 1,
    page_size: 20,
    sort: 'ahoy_updated_at',
    order: 'desc',
  },

  showTimeFilter: false,
};
